import * as React from "react";
import classNames from "classnames";

export interface IOption {
	value: string;
	text: string;
}

interface IProps {
	className?: string;
	children?: {};
	isOpen: boolean;
}

class FormCheckConditional extends React.Component<IProps> {
	public render() {
		const { className, children, isOpen } = this.props;
		return isOpen ? (
			<div className={classNames("form-check-conditional", className)}>
				<div className="form-check-conditional-content-wrapper">
					<div className="form-check-conditional-content mt-1 mb-3">
						{children}
					</div>
				</div>
			</div>
		) : null;
	}
}

export default FormCheckConditional;
